import React from 'react';
import MediaRemoteVideo from 'src/components/media/MediaRemoteVideo';
import { getMedia } from 'src/utils/mediaHelpers';

const ArticleMedia = ({ node, mediaType }: { node: IArticleContent; mediaType: string }) => {
  let media = null;
  switch (mediaType) {
    case 'media__remote_video':
      media = <MediaRemoteVideo {...node.relationships.field_media} />;
      break;
    case 'media__infographic':
      media = getMedia({ media: node.relationships.field_media, loading: 'eager' });
      break;
    default:
      media = getMedia({ media: node.relationships.field_image, loading: 'eager' });
      break;
  }

  return media;
};

export default ArticleMedia;
